import { createSelector } from 'reselect'

export const selectSubscriptionFormConfiguration = state => state.subscriptionFormConfiguration

export const selectSubscriptionFormConfigurationData = createSelector(selectSubscriptionFormConfiguration, data => data)

export const selectCommonFormConfigurationData = createSelector(
  selectSubscriptionFormConfiguration,
  data => data.common,
)
